/*
 * @Author: Latte
 * @Date: 2021-11-09 16:30:02
 * @LAstEditors: Latte
 * @LastEditTime: 2021-11-09 16:40:57
 * @FilePath: \Siui.Cloud.Medical.Web\src\api\system\contentSecurity\AdminContentSecure.js
 */
import request from "@/utils/request";
import config from "@/utils/config";
import {handleUrlEncode} from "@/utils/urlutil";

/**
 * 后台分页获取所有内容安全审核记录(图片、视频、文本)列表
 * @param {*} params
 * @returns
 */
export function getContentSecureRecordList(params) {
    let url = config.API_ADMIN + "/Api/V1/AdminContentSecure/List?";
    url = handleUrlEncode(url, params)
    return request({
        url: url,
        method: "get",
    });
}

/**
 * 后台设置内容安全记录的状态（违规或正常）
 * @param {*} data
 * @returns
 */
export function auditContentSecureStatus(data) {
    return request({
        url: config.API_ADMIN + "/Api/V1/AdminContentSecure/Audit",
        method: "post",
        data,
    });
}

/**
 * 后台删除或者恢复内容安全记录
 * @param {*} params
 * @returns
 */
export function secureRecordDeleteOrBack(data) {
    return request({
        url: config.API_ADMIN + "/Api/V1/AdminContentSecure/DeleteOrBack",
        method: "delete",
        data,
    });
}
